import styled from 'styled-components';

export const Container = styled.div`
  &.leaflet-bar-current-location {
    font-size: 18px;
  }
`;

export default Container;
